import React, {
  FC,
  ReactElement,
} from 'react';
import { styled } from '@core-ui/react-stitch';
import {
  LARGE,
  MEDIUM,
  SMALL,
  XLARGE,
} from '@core-ui/breakpoint-provider';
import GridContainer from '../GridContainer';
import GridElement from '../GridElement';
import {
  GridData,
  GridProps,
} from './types';

const DEFAULT_COLUMNS = {
  [XLARGE]: 3,
  [LARGE]: 3,
  [MEDIUM]: 2,
  [SMALL]: 2,
};

const DEFAULT_SIZES = {
  [XLARGE]: 1,
  [LARGE]: 1,
  [MEDIUM]: 1,
  [SMALL]: 1,
};

type GridSectionProps = {
  isBRRedesignEnabled?: boolean;
};

const GridSection = styled.section<GridSectionProps>(({ isBRRedesignEnabled }) => ({
  boxSizing: 'border-box',
  ...(!isBRRedesignEnabled && {
    padding: '0.5em'
  })
}));

const Grid: FC<GridProps> = (props: GridProps): ReactElement => {
  const {
    data,
    contents,
    index,
    columns,
    spacing,
    isBRRedesignEnabled
  } = props;

  return (
    <GridSection isBRRedesignEnabled={isBRRedesignEnabled}>
      <GridContainer key={index} columns={{ ...DEFAULT_COLUMNS, ...columns }} isBRRedesignEnabled={isBRRedesignEnabled}>
        {data.map(({ type = '', sizes, ...data }: GridData, i: number) => {
          const ElementUi = contents[type] || contents.default;
          return (
            // eslint-disable-next-line react/no-array-index-key
            <GridElement key={`grid${index}:element${i}`} sizes={{ ...DEFAULT_SIZES, ...sizes }} spacing={spacing}>
              <ElementUi {...data} />
            </GridElement>
          );
        })}
      </GridContainer>
    </GridSection>
  );
};

export default Grid;
